import { HeadingTwo } from '~/@mid_ui/typography/HeadingTwo'
import { Button } from '~/shadcn/ui/button/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '~/shadcn/ui/dialog'

type Props = { onClose(): void }

/**
 * Po expirácii dokladu prešiel user Veriffom znova, ale údaje z nového dokladu nesedia s účtom
 * (BE status `reverification_mismatch`: rodné číslo, prípadne dátum narodenia). Identita ostáva
 * stará, user je ďalej blokovaný. „Skúsiť znova“ zavrie modal — pod ním je bežný formulár na Veriff.
 */
function IdentityVerificationMismatchDialog({ onClose }: Props) {
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <div className="flex flex-col items-center gap-8 py-8 text-center md:p-8">
          <DialogTitle asChild>
            <HeadingTwo>Doklad sa nepodarilo priradiť k vášmu účtu</HeadingTwo>
          </DialogTitle>
          <DialogDescription asChild>
            <div className="flex flex-col gap-4 !text-foreground">
              <p>
                Údaje z nahraného dokladu sa nezhodujú s údajmi, ktoré evidujeme
                vo vašom účte. Skontrolujte prosím, či nahrávate vlastný a
                platný doklad totožnosti.
              </p>
              <p>
                Ak máte pocit, že je všetko v poriadku,{' '}
                <a
                  href="https://investinslovakia.eu/kontakt"
                  target="_blank"
                  rel="noreferrer"
                  className="text-accent underline">
                  kontaktujte našu podporu
                </a>
                .
              </p>
            </div>
          </DialogDescription>
          <img
            src="/images/identity-mismatch.png"
            alt=""
            width={460}
            height={336}
            className="w-full"
          />
          <Button
            variant="accent"
            className="w-full"
            size="3xl"
            onClick={onClose}>
            Skúsiť znova
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export { IdentityVerificationMismatchDialog }
